import React from "react";
import Form from "react-bootstrap/Form";

/**
 * KHAN-146: envoltorio de campo reutilizable para formularios con
 * react-hook-form + Zod.
 *
 * Antes cada formulario repetia el mismo bloque de label + control y, sobre
 * todo, no mostraba errores por campo: la validacion se limitaba al `required`
 * de HTML y los errores del servidor salian por `alert()`. Este componente
 * concentra las tres cosas que deben ser iguales en toda la app:
 *
 *   1. la etiqueta con su icono,
 *   2. el control registrado en react-hook-form,
 *   3. el mensaje de error debajo, con aria-invalid para lectores de pantalla.
 *
 * Uso:
 *   <FormField
 *     id="emailInput"
 *     label="Email"
 *     icon={faEnvelope}
 *     type="email"
 *     placeholder="example@mep.co.cr"
 *     error={errors.email}
 *     registration={register("email")}
 *   />
 */
function FormField({
  id,
  label,
  icon,
  type = "text",
  placeholder,
  error,
  registration,
  className = "",
  iconClassName = "",
  children,
  ...controlProps
}) {
  const describedBy = error ? `${id}-error` : undefined;

  const control = (
    <Form.Control
      id={id}
      size="lg"
      type={type}
      placeholder={placeholder}
      className={className}
      // El borde se pinta con una clase segun si el campo tiene error, en vez
      // de escribir estilos con document.getElementById como se hacia antes.
      isInvalid={Boolean(error)}
      aria-invalid={error ? "true" : "false"}
      aria-describedby={describedBy}
      {...registration}
      {...controlProps}
    />
  );

  return (
    <Form.Group className="form-group">
      <Form.Label className="font-size" htmlFor={id}>
        {icon}
        {label}
      </Form.Label>
      {/* children permite envolver el control (ej. el InputGroup con el ojito
          de mostrar/ocultar contraseña) sin duplicar toda esta estructura. */}
      {children ? children(control) : control}
      {error ? (
        <div id={describedBy} className="form-field-error" role="alert">
          {error.message}
        </div>
      ) : null}
    </Form.Group>
  );
}

export default FormField;
